import Phaser from 'phaser';

import { BlocksMainScene } from '../../scenes/blocks-main-scene';
import { GameSizeMetrics } from 'src/games/common/phaser/game/scenes/scaled-base-scene';
import { Subscription } from 'rxjs';
import { LoadingGridViewModel } from './loading-grid-view-model';
import { LoadingCellView } from './loading-cell-view';

export class LoadingGridView extends Phaser.GameObjects.Container {
  private currentResizeMetrics?: GameSizeMetrics;

  private subscriptionGroup: Subscription;
  private cellViews: LoadingCellView[] = [];

  constructor(
    scene: BlocksMainScene,
    x: number,
    y: number,
    private viewModel: LoadingGridViewModel,
  ) {
    super(scene, x, y);

    this.subscriptionGroup = new Subscription();

    this.setName(LoadingGridView.name);
    scene.add.existing(this);

    this.subscriptionGroup.add(
      this.viewModel.onGameSetupStart$.subscribe(() => {
        this.viewModel.onGameSetupStart();
      }),
    );
    this.subscriptionGroup.add(
      this.viewModel.showLoadingGrid$.subscribe((show) => {
        if (show && this.cellViews.length > 0) {
          return;
        }

        this.cellViews.forEach((view) => view.destroy());
        this.cellViews.length = 0;

        if (show) {
          this.cellViews = viewModel.allLoadingCellViewModels.map((vm) => {
            const view = new LoadingCellView(scene, 0, 0, vm);
            const delay = (view.row + view.column) * 100 + Math.random() * 500;
            view.animateIn(delay);
            return view;
          });
        }
        this.refreshLayout(this.currentResizeMetrics);
      }),
    );
  }

  override destroy(fromScene?: boolean | undefined): void {
    this.subscriptionGroup.unsubscribe();

    super.destroy(fromScene);
  }

  public onResize(gameSizeMetrics: GameSizeMetrics) {
    this.currentResizeMetrics = gameSizeMetrics;
    this.refreshLayout(gameSizeMetrics);
  }

  private refreshLayout(gameSizeMetrics?: GameSizeMetrics): void {
    if (!gameSizeMetrics) {
      return;
    }
    this.cellViews.forEach((view) => view.onResize(gameSizeMetrics));
  }
}
